export default class ResultadoPesquisa {
  sucesso: boolean
  mensagem: string
  cor: string

  constructor(sucesso: boolean, mensagem: string, cor: string) {
    this.sucesso = sucesso
    this.mensagem = mensagem
    this.cor = cor
  }
}
